import React from 'react';
import DashboardPage from '@peoplenet/vi-components-ui/src/Dashboard';

const dashboard = (props) => {
  return <DashboardPage {...props} />
};

export default dashboard;
